export default {
  LOAD_LIST_EVENT_TYPES(state, data) {
    state.listaEventTypes = data;
  },
  PREPARE_TO_EDIT_EVENT_TYPE(state, data) {
    state.eventType = data;
  },
  RESET_EVENT_TYPE(state) {
    state.eventType = {
      nome: "",
      ativo: true,
    };
  },
};
